import { takeLatest, call, put, select } from "redux-saga/effects";
import {
  GET_AZURE_CONSOLE_LOGS,
  GET_AZURE_CONSOLE_LOGS_SUCCESS,
  GET_AZURE_CONSOLE_LOGS_ERROR,
} from "./constant";

import { getAzureConsoleLogsApi } from "./api";

/**
 * action Type of GET_DASHBOARD_INFO
 * @param {Object} action
 */
function* getAzureConsoleLogsList(params) {
  try {
    const provider = yield select(state => state.CloudProviderStore ? state.CloudProviderStore.selectedProvider : "azure");
    const data = yield call(getAzureConsoleLogsApi, params, provider);

    yield put({ type: GET_AZURE_CONSOLE_LOGS_SUCCESS, data });
  } catch (error) {
    yield put({ type: GET_AZURE_CONSOLE_LOGS_ERROR, error });
  }
}

/**
 * Get Login Saga
 */
export function* manageAzureConsoleLogsSaga() {
  yield takeLatest(GET_AZURE_CONSOLE_LOGS, getAzureConsoleLogsList);
}
